// extracted by mini-css-extract-plugin
module.exports = {"chartsContainer":"ChartAnimal_chartsContainer__22LNM","notDevice":"ChartAnimal_notDevice__30_cx"};